export const scrollToEvent = (offset, callback) => {
  const fixedOffset = offset.toFixed();
  const onScroll = function () {
    if (window.scrollY.toFixed() === fixedOffset) {
      window.removeEventListener("scroll", onScroll);
      callback();
    }
  };

  window.addEventListener("scroll", onScroll);
  onScroll();
  window.scrollTo({
    top: offset,
    behavior: "smooth",
  });
};

export const getIndex = (item) => {
  const nodes = Array.prototype.slice.call(item.parentElement.children);
  return nodes.indexOf(item);
};

export const debounce = (func, delay = 1000) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const validation = (el, operation, message = "pole obowiązkowe") => {
  if (operation === "add") {
    el.closest("fieldset").classList.add("has-error");
    el.closest("fieldset").setAttribute("data-error", message);
  } else if (operation === "remove") {
    el.closest("fieldset").classList.remove("has-error");
    el.closest("fieldset").setAttribute("data-error", "");
  }
};

export const validateFileInput = (el, file) => {
  const maxSize = 2 * 1024 * 1024; // 2MB
  const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

  // Check file type first - if wrong, show type error
  if (!allowedTypes.includes(file.type)) {
    validation(el, "add", "Dozwolone są tylko pliki JPG i PNG");
    return false;
  }

  // Only check size if type is correct - if too large, show size error
  if (file.size > maxSize) {
    validation(el, "add", "Plik jest za duży. Maksymalny rozmiar to 2MB");
    return false;
  }

  // Both validations passed - remove any errors
  validation(el, "remove");
  return true;
};

export const validateTextInput = (el, char) => {
  // const isValid = el.value.trim().length > char && !/\d/.test(el.value);
  const isValid = el.value.trim().length > char;

  if (!isValid) {
    validation(el, "add");
  } else {
    validation(el, "remove");
  }
  return isValid;
};

export const validateTextarea = (el, char, maxChar = null) => {
  const length = el.value.trim().length;
  let isValid = length > char;

  // Check max character limit if provided
  if (maxChar && length > maxChar) {
    validation(el, "add", `Maksymalna liczba znaków to ${maxChar}`);
    return false;
  }

  if (!isValid) {
    validation(el, "add");
  } else {
    validation(el, "remove");
  }
  return isValid;
};

export const updateCharCounter = (textarea) => {
  const charLimit = parseInt(textarea.getAttribute('data-char-limit'));
  if (!charLimit) return;

  const currentLength = textarea.value.length;
  const counter = textarea.closest('fieldset').querySelector(`[data-for="${textarea.id}"]`);

  if (counter) {
    counter.textContent = `${currentLength} / ${charLimit} znaków`;

    // Optional: add warning class when approaching limit
    if (currentLength >= charLimit * 0.9) {
      counter.classList.add('char-counter--warning');
    } else {
      counter.classList.remove('char-counter--warning');
    }
  }
};

export const validateSelectField = (el) => {
  const fieldset = el.closest("fieldset");
  if (el.value === "" || el.value.length === 0) {
    fieldset.classList.add("has-error");
    el.closest("fieldset").setAttribute("data-error", "pole obowiązkowe");
    return false;
  } else {
    fieldset.classList.remove("has-error");
    el.closest("fieldset").setAttribute("data-error", "");
    return true;
  }
};

// const checkPhoneNumber = (phoneNumber) => {
//   const regex = /^(?=.{1,20}$)(\+)?([0-9]+[-]?){1,3}[0-9]+$/;
//   if (regex.test(phoneNumber)) {
//     const plusCount = (phoneNumber.match(/\+/g) || []).length;
//     if (plusCount > 1) {
//       return false;
//     }
//     if (phoneNumber.length < 7) {
//       return false;
//     }
//     if (phoneNumber.endsWith('-')) {
//       return false;
//     }
//     if (phoneNumber.includes('--')) {
//       return false;
//     }
//     const repeatingSequenceRegex = /(.)\1{2,}/;
//     return !repeatingSequenceRegex.test(phoneNumber);
//   }
//   return false;
// };

// export const validatePhoneNumber = (phoneNumber) => {
//   const isValid = checkPhoneNumber(phoneNumber.value);
//
//   if (!isValid) {
//     validation(phoneNumber, 'add');
//   } else {
//     validation(phoneNumber, 'remove');
//   }
//   return isValid;
// };

export const validateCheckbox = (el) => {
  if (!el.checked) {
    validation(el, "add");
  } else {
    validation(el, "remove");
  }
  return el.checked;
};

export const checkEmail = (emailAddress) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z\-0-9]{2,}))$/;
  return re.test(String(emailAddress).toLowerCase());
};

export const validateEmail = (el) => {
  const isValid = checkEmail(el.value);

  if (!isValid) {
    validation(el, "add");
  } else {
    validation(el, "remove");
  }
  return isValid;
};

const spinnerHtml = `<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
   <circle class="path" fill="none" stroke-width="3" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
</svg>`;

export const createSpinner = (formEl, opacity) => {
  formEl.querySelectorAll("input, textarea, button").forEach((input) => {
    input.setAttribute("disabled", "");
  });
  if (opacity) {
    formEl.classList.add("form-opacity");
  }
  const spinnerWrapper = document.createElement("div");
  spinnerWrapper.classList.add("spinner-wrapper");
  spinnerWrapper.innerHTML = spinnerHtml;
  formEl.append(spinnerWrapper);
};

export const splitString = (el, letter = true) => {
  const text = el.innerText;
  const items = letter ? text.split("") : text.split(" ");
  el.innerHTML = items
    .map((item) => `<span>${item}</span>`)
    .join(letter ? "" : " ");
};

export const cutText = function (selector, length) {
  if (document.querySelectorAll(selector).length > 0) {
    document.querySelectorAll(selector).forEach((el) => {
      if (el.innerText.length > length) {
        el.innerText = `${el.innerText.substr(0, length)}\u2026`;
      }
    });
  }
};
